import { ButtonGroup } from "@themes/pollinator/ui/ButtonGroup";

export type TabValue = "profile" | "coworkers" | "tracking" | "outreach";

export type Props = {
  /** Currently active tab */
  activeTab: TabValue;
  /** Callback when tab is clicked */
  onTabChange: (tab: TabValue) => void;
  /** Additional CSS classes */
  className?: string;
};

const TABS = [
  { label: "Outreach", value: "outreach" as const },
  { label: "Tracking", value: "tracking" as const },
  { label: "Profile", value: "profile" as const },
  { label: "Coworkers", value: "coworkers" as const },
];

/**
 * Tab navigation for organization admin pages.
 * Uses ButtonGroup with tabs layout for consistent styling.
 * Designed to be used inside AppPageHeader's tabs prop.
 */
export function OrgAdminTabs({ activeTab, onTabChange, className }: Props) {
  return (
    <div className={className} data-testid="org-admin-tabs">
      <ButtonGroup
        layout="tabs"
        buttons={TABS.map((tab) => ({
          label: tab.label,
          onClick: () => onTabChange(tab.value),
          isActive: activeTab === tab.value,
        }))}
      />
    </div>
  );
}

export default OrgAdminTabs;
